export const HEADER_EDIT_BUTTON_CONFIG = {
	paddingHorizontal: 12,
}